export class AdapterGarageBays{
    bays;
    garage;
}